import axios from 'axios';
import { API_DOMAIN } from '../../../components/constants';
import { authHeaders } from '../../../components/qv4/models/shared/apiClient';
import { monthLabel } from './reconciliation';
export function attendanceNotice(row) {
  if (!Number.isInteger(row?.id) || row.id <= 0) return null;
  const base = { key: `attendance:${row.id}`, body: row.body || '' };
  switch (row.type) {
    case 'attendance_review_digest': return { ...base, title: 'Attendance items need review', route: '/settings/attendance/review-queue' };
    case 'attendance_deadline_reminder': return { ...base, title: row.title || 'Attendance update', route: '/settings/attendance/my-attendance?tab=explain', own: true };
    case 'attendance_decided': return { ...base, title: row.title || 'Attendance update', route: `/settings/attendance/my-attendance?tab=${row.data?.review_kind === 'correction_request' ? 'corrections' : 'explain'}`, own: !row.data?.review_kind };
    case 'attendance_month_unlocked': return /^\d{4}-(0[1-9]|1[0-2])$/.test(row.data?.month || '') ? { ...base, title: `${monthLabel(row.data.month)} was unlocked`, route: '/settings/attendance/month-locks', month: row.data.month } : null;
    default: return null;
  }
}
export function markAttendanceNoticeRead(id) { return axios.post(`${API_DOMAIN}/notifications/${id}/read`, undefined, authHeaders()); }
